import React from "react";

import { MdmObjectDto, useGetObjectsByProjectQuery } from "gql/generated/types";
import { Link } from "react-router-dom";
import { TableColumn } from "utils/types";
import MainTable from "../components/MainTable";
import useProjectContext from "../hooks/useProjectContext";


const Objects = () => {
  const {projectId} = useProjectContext();

  const { data: objectData, loading } = useGetObjectsByProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });

  const objectInfoBtn = (rowData: MdmObjectDto) => (
    <Link to={`objects/${rowData.id}`} title="Object Info">
      {rowData.identifier}
    </Link>
  );

  const columns: TableColumn<MdmObjectDto>[] = [
    { field: "identifier", header: "Identifier", body: objectInfoBtn, sortable: true },
    { field: "title", header: "Object Name", sortable: true },
    {
      field: "address.fullAddress",
      header: "Address",
      sortable: true,
    },
  ];

  return (
    <MainTable
      columns={columns}
      data={objectData?.mdmObjectsByProjectId ?? []}
      tableType="object"
      searchFields={["identifier", "title", "address.fullAddress"]}
      loading={loading}
    />
  );
};

export default Objects;
